/**
 * Texto de los avisos de agentes de un plan (#458).
 *
 * Las marcas las calcula el backend (`planService.annotateMissingRoles`) leyendo
 * `plan_data_pure.steps`, que es lo que de verdad se ejecuta: `rolesCount` sale de
 * la tabla puente, y como el CASCADE la limpia al borrar el agente, el plan parece
 * más sano cuanto más roto está.
 *
 * Dos estados, dos avisos — la diferencia importa:
 * - `missingRoles` (rojo): el agente se borró y no hay vuelta atrás. El paso no
 *   puede ejecutarse; el plan sí se puede guardar y eliminar (`updatePlan` omite los
 *   rolId inexistentes de la puente, y `deletePlan` no mira los roles). Se arregla
 *   quitando el paso.
 * - `archivedRoles` (ámbar): el agente sigue existiendo pero archivado. El plan se
 *   guarda y se ejecuta porque la fila sigue ahí y las queries de ejecución no
 *   filtran archivados, así que NO se bloquea; lo que pasa es que el agente ya no
 *   sale en la lista del usuario. Se arregla desarchivándolo.
 *
 * Vive aparte de los componentes porque lo usan tanto la lista del editor como la
 * del sidebar, y no conviene que el sidebar arrastre el grafo de imports de
 * `PlanList`.
 */

/** Nombres de los agentes + total de pasos afectados de un cubo. */
function summarize(entries, t) {
  // El nombre sobrevive en el JSON del paso aunque el agente ya no exista: es lo
  // único que se le puede enseñar al usuario para que sepa de qué se trata.
  const agents = entries
    .map((m) => m.rolName || t('planList.brokenPlan.unnamedAgent'))
    .join(', ');

  const count = entries.reduce((total, m) => total + (m.stepIds?.length || 0), 0);

  return { agents, count };
}

/**
 * Aviso de agentes borrados.
 * @returns {string} Texto listo para un tooltip, o '' si no hay ninguno.
 */
export function describeMissingRoles(plan, t) {
  const entries = plan?.missingRoles || [];
  if (entries.length === 0) return '';

  return t('planList.brokenPlan.tooltip', summarize(entries, t));
}

/**
 * Aviso de agentes archivados.
 * @returns {string} Texto listo para un tooltip, o '' si no hay ninguno.
 */
export function describeArchivedRoles(plan, t) {
  const entries = plan?.archivedRoles || [];
  if (entries.length === 0) return '';

  return t('planList.archivedPlan.tooltip', summarize(entries, t));
}
